import { defineComponent as _defineComponent } from 'vue'
import type { BoxData } from './index';


export default /*#__PURE__*/_defineComponent({
  __name: 'BoxElement',
  props: {
    boxData: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'click', value: BoxData): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { boxData: BoxData<unknown> };





const handleOnClick = () => {
    if (!props.boxData) return;

    emit('click', props.boxData);
};

return { __sfc: true,props, emit, handleOnClick }
}

})